export const contentTableConfig = {
  title: '老师列表',
  propList: [
    { prop: 'name', label: '名字', minWidth: '120' },
    { prop: 'enName', label: '拼音简写', minWidth: '80' },
    { prop: 'cover', label: '封面', minWidth: '80', slotName: 'cover' },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
